import isString from 'lodash/isString';
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const transformJSONStringToObject = (value: string | unknown): any => {
	try {
		if (isString(value) && JSON.parse(value)) {
			return JSON.parse(value);
		}
	} catch (e) {
		return value;
	}
	return value;
};
